module.exports = __webpack_public_path__ + "static/12-cc2a45b4b63faa723b825e13906e375e.jpg";